import {combineReducers} from 'redux';

function filter(state = '', action) {
  switch (action.type) {
    case 'SEARCH_SUCCESS':
      return action.filter;
    default:
      return state;
  }
}

export default combineReducers({
  filter
});



// WEBPACK FOOTER //
// ./reducers/search.js